import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Sparkles, X } from "lucide-react";

export default function DemoTooltip({ message, position = "bottom" }) {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (user?.email !== "demo@aurorageriatrica.com") return null;
  if (dismissed) return null;

  const positionClasses = {
    bottom: "top-full mt-2 left-0",
    top: "bottom-full mb-2 left-0",
    right: "left-full ml-2 top-0",
  };

  return (
    <div className={`absolute z-50 ${positionClasses[position] || positionClasses.bottom}`}>
      <div className="relative flex max-w-xs items-start gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2.5 shadow-lg">
        <Sparkles className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-600" />
        <p className="text-xs leading-relaxed text-emerald-900">{message}</p>
        <button
          onClick={() => setDismissed(true)}
          className="ml-1 shrink-0 text-emerald-400 hover:text-emerald-700"
          aria-label="Cerrar"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    </div>
  );
}
